module.exports = __webpack_public_path__ + "static/media/relativity.3b98c903.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/relativity.png
// module id = 473
// module chunks = 0